import React from "react";
import { objectiveFilterType } from "../../../types";

interface Props {
  data: any;
  showModal: boolean;
  setRadioChecked: (name: string, id: string) => void;
  filterDone: (e: React.MouseEvent<HTMLElement>) => void;
  filterClear: (e: React.MouseEvent<HTMLElement>) => void;
}

const ObjectiveFilter = ({
  data,

  filterDone,
  filterClear,
  setRadioChecked,
}: Props) => {
  return (
    <div className="card card-compact flex flex-col  bg-white z-20 justify-start  w-72 h-96   shadow-2xl shadow-black ">
      <div className="w-full p-2  rounded-xl text-sm text-center">فیلتر</div>
      <div className="flex flex-col justify-between h-80 px-4 pb-1 mt-1 overflow-y-auto">
        <div
          className={`${
            data.stateDtos && data.stateDtos.length > 0 ? "" : "hidden"
          } w-full flex flex-col my-1 justify-center border-t-2 gap-1.5`}
        >
          <div className="flex h-10 items-center">
            <span className="label-text">بر اساس وضعیت</span>
          </div>
          {data.stateDtos.map((item: objectiveFilterType) => (
            <div className={`w-full flex  items-center text-xs`}>
              <input
                type="checkbox"
                name="stateDtos"
                // value={item.id}
                onChange={() => setRadioChecked("stateDtos", item.id)}
                defaultChecked={item.checked}
                className="checkbox checkbox-xs ml-1 mr-2  checkbox-primary"
              />{" "}
              <span className="">{item.name}</span>
              <span className="mr-auto">{item.count}</span>
            </div>
          ))}
        </div>
        <div
          className={`${
            data.teamDtos && data.teamDtos.length > 0 ? "" : "hidden"
          } w-full flex flex-col my-1 justify-center border-t-2 gap-1.5`}
        >
          <div className="flex h-10 items-center">
            <span className="label-text">بر اساس سطح</span>
          </div>

          {data.teamDtos.map((item: objectiveFilterType) => (
            <div className={` w-full flex  items-center text-xs`}>
              <input
                type="checkbox"
                name="teamDtos"
                // value={item.id}
                onChange={() => setRadioChecked("teamDtos", item.id)}
                defaultChecked={item.checked}
                className="checkbox checkbox-xs 	ml-1  mr-2  checkbox-primary"
              />{" "}
              <span className="">{item.name}</span>
              <span className="mr-auto">{item.count}</span>
            </div>
          ))}
        </div>
        <div
          className={`${
            data.personDtos && data.personDtos.length > 0 ? "" : "hidden"
          } w-full flex flex-col my-1 justify-center border-t-2 gap-1.5`}
        >
          <div className="flex h-10 items-center">
            <span className="label-text">بر اساس پرسنل</span>
          </div>

          {data.personDtos.map((item: objectiveFilterType, idx: number) => (
            <div key={idx} className={` w-full flex  items-center text-xs`}>
              <input
                type="checkbox"
                name="personDtos"
                // value={item.id}
                onChange={() => setRadioChecked("personDtos", item.id)}
                defaultChecked={item.checked}
                className="checkbox checkbox-xs ml-1  mr-2  checkbox-primary"
              />{" "}
              <span className="">{item.name}</span>
              <span className="mr-auto">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="flex justify-between w-full h-11 items-start">
        <div className="h-3/4 w-1/2">
          <button
            onClick={(e: React.MouseEvent<HTMLElement>) => filterDone(e)}
            className=" bg-blue-800 text-white  px-3 h-full mr-2 rounded-md text-xs w-5/6"
          >
            اعمال فیلتر
          </button>
        </div>
        <div className="h-3/4 w-1/2 text-left">
          <button
            onClick={(e: React.MouseEvent<HTMLElement>) => filterClear(e)}
            className=" bg-white text-blue-600 border border-blue-600 px-3 h-full ml-2  rounded-md text-xs w-5/6"
          >
            حذف فیلتر
          </button>
        </div>
      </div>
    </div>
  );
};

export default ObjectiveFilter;
